import React from 'react';
import Select from 'react-select';
import Images from './images';
import { isStringArray } from '@app/utilities/create-meal-helper';

const Details = ({
  value,
  options,
  countries,
  handleChange,
  setFieldValue,
  images,
  handlePickImage,
  removeImage,
  categories,
  tags
}) => {
  return (
    <div>
      <div className="flex flex-col flex-1 gap-4">
        <div>
          <Images
            handleImage={handlePickImage}
            image={images}
            removeImage={removeImage}
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[#14151A] text-[14px] font-medium">
            Name <span className="text-[12px] text-red-500">*</span>
          </label>
          <Input
            name="name"
            handleChange={handleChange}
            value={value.name}
            isRequired={true}
            placeholder="Name"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-[#14151A] text-[14px] font-medium">Video URL</label>
          <Input
            name="video_url"
            handleChange={handleChange}
            value={value.video_url}
            isRequired={false}
            placeholder="Video URL"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-[#14151A] text-[14px] font-medium">
            Notifcation Message
          </label>
          <TextArea
            name="notification_message"
            placeholder={'Notification Message'}
            value={value.notification_message}
            handleChange={handleChange}
            isRequired={false}
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-[#14151A] text-[14px] font-medium">
            Description <span className="text-[12px] text-red-500">*</span>
          </label>
          <TextArea
            name="description"
            placeholder={'Description'}
            value={value.description}
            handleChange={handleChange}
            isRequired={true}
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-[#14151A] text-[14px] font-medium">Lu Tips</label>
          <TextArea
            name="lu_tips"
            placeholder={'Lu Tips'}
            value={value.lu_tips}
            handleChange={handleChange}
            isRequired={false}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              Type <span className="text-[12px] text-red-500">*</span>
            </label>
            <Select
              name="types"
              isMulti
              options={options}
              value={value.types}
              className="text-sm font-normal rounded-md w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
              onChange={(value) => {
                setFieldValue('types', value);
              }}
              required
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              Category
            </label>
            <Select
              isMulti
              options={categories}
              value={value.categories}
              className="text-sm font-normal rounded-md w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
              onChange={(value) => {
                setFieldValue('categories', value);
              }}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              Tags <span className="text-[12px] text-red-500">*</span>
            </label>
            <Select
              isMulti
              options={tags}
              isSearchable={true}
              value={value.tags}
              className="text-sm font-normal rounded-md w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
              onChange={(value) => {
                setFieldValue('tags', value);
              }}
              required
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              Countries <span className="text-[12px] text-red-500">*</span>
            </label>
            <Select
              isMulti
              options={countries}
              value={
                isStringArray(value.countries)
                  ? value.countries?.map((item) => {
                      return { value: item, label: item };
                    })
                  : value.countries
              }
              className="text-sm font-normal rounded-md w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
              onChange={(value) => {
                setFieldValue('countries', value);
              }}
              required
            />
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-[#14151A] text-[14px] font-medium">
            Cook Time <span className="text-[12px] text-red-500">*</span>
          </label>
          <Input
            name="prep_time"
            handleChange={(e) => {
              const raw = e.target.value;
              const numericOnly = raw.replace(/[^0-9]/g, '');
              setFieldValue(
                'prep_time',
                numericOnly === '' ? '' : Number(numericOnly)
              );
            }}
            value={value.prep_time}
            isRequired={true}
            placeholder="Cook Time"
            type="text"
            inputMode={'numeric'}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              No. of servings
            </label>
            <Input
              name="servings"
              handleChange={(e) => {
                const raw = e.target.value;
                const numericOnly = raw.replace(/[^0-9]/g, '');
                setFieldValue(
                  'servings',
                  numericOnly === '' ? '' : Number(numericOnly)
                );
              }}
              value={value.servings}
              isRequired={false}
              placeholder="Servings"
              type="text"
              inputMode="numeric"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              Total Calories
            </label>
            <Input
              name="total_calories"
              handleChange={(e) => {
                const raw = e.target.value;
                const numericOnly = raw.replace(/[^0-9]/g, '');
                setFieldValue(
                  'total_calories',
                  numericOnly === '' ? '' : Number(numericOnly)
                );
              }}
              value={value.total_calories}
              isRequired={false}
              placeholder="Total Calories"
              type="text"
              inputMode={'numeric'}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-[#14151A] text-[14px] font-medium">
              Calories per serving
            </label>
            <Input
              name="calorie_per_serving"
              handleChange={(e) => {
                const raw = e.target.value;
                const numericOnly = raw.replace(/[^0-9]/g, '');
                setFieldValue(
                  'calorie_per_serving',
                  numericOnly === '' ? '' : Number(numericOnly)
                );
              }}
              value={value.calorie_per_serving}
              isRequired={false}
              placeholder="Calories per serving"
              type="text"
              inputMode={'numeric'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;

const Input = ({
  name,
  handleChange,
  value,
  isRequired,
  placeholder,
  type,
  inputMode
}) => {
  return (
    <input
      type={type || 'text'}
      name={name}
      onChange={handleChange}
      value={value}
      placeholder={placeholder}
      required={isRequired}
      inputMode={inputMode}
      className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
    />
  );
};

const TextArea = ({ name, handleChange, value, isRequired, placeholder }) => {
  return (
    <textarea
      type="text"
      rows={5}
      name={name}
      onChange={handleChange}
      value={value}
      placeholder={placeholder}
      required={isRequired}
      className="border-[1px] border-[#DEE0E3] text-sm font-normal placeholder:text-[#0D112666] rounded-md p-2 w-full outline-none duration-700 ease-in-out focus:border-[#003333] focus:border-opacity-50 focus:shadow-nject-primary focus:ring focus:ring-[#ACD1D1] focus:ring-opacity-30"
    />
  );
};
